/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

const TOGGLE_STATISTIC_VISIBILITY = 'TOGGLE_STATISTIC_VISIBILITY'

export default {
  namespaced: true,
  state: {
    showStats: false,
  },
  getters: {
    showStats: state => state.showStats,
  },
  actions: {
    toggleStatisticVisibility({ commit }) {
      commit(TOGGLE_STATISTIC_VISIBILITY)
    },
  },
  mutations: {
    [TOGGLE_STATISTIC_VISIBILITY](state) {
      state.showStats = !state.showStats
    },
  },
}
